module.exports = __webpack_public_path__ + "img/google.23ef28cc.png";